import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';
import { volumeResponse } from 'src/interface/volumeIssue';

@Injectable({
    providedIn: 'root'
})
export class VolumeService {

    constructor(private http: HttpClient, private EnvService: EnvService) { }

    getVolumeIssues(journal_id: string): Observable<volumeResponse> {
        return this.http.get<volumeResponse>(this.EnvService.siteApiUrl + 'web/' + journal_id + '/volumes-issues');
    }

    getThematic(journal_id: string): Observable<volumeResponse> {
        return this.http.get<volumeResponse>(this.EnvService.siteApiUrl + 'web/' + journal_id + '/thematic-issues');
    }
    getLatestIssue(journal_id: string): Observable<volumeResponse> {
        return this.http.get<volumeResponse>(this.EnvService.siteApiUrl + 'web/' + journal_id + '/latest-issues');
    }
}
